module.exports = __webpack_public_path__ + "img/zz10.2fa32764.png";